<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    پیام ها
                    <!--<button data-menu="notificationHelp" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="ml-3 mr-3 alert alert-small rounded-s shadow-xl bg-green1-dark" role="alert">
                <span><i class="fa fa-check"></i></span>
                <strong>شما {{NewListCount}}  پیام خوانده نشده دارید!</strong>
                <button type="button" class="close color-white opacity-60 font-16" data-dismiss="alert" aria-label="Close">×</button>
            </div>

            <div class="card card-style mb-2" v-for="n in notificationList" :key="n.notificationId" :class="{'bg-yellow1-light': n.status==false}">
                <div class="list-group list-custom-small list-icon-0">
                    <div class="p-3">
                        <div>
                            <div>
                                <i class="fa fa-calendar ml-3" :class="{'text-white': n.status==false,'text-warning': n.status==true}"></i>
                                <span class="text-muted ltr">{{n.registerDateTime}}</span>
                                <button class="btn" @click="deleteNotif(n)" style="float:left;margin-left:-15px;"><i class="fa fa-trash color-red1-light font-14 ml-0"></i></button>
                            </div>
                            <div @click.prevent="openDetails(n)">
                                <div>
                                    <i class="fa fa-check color-red1-dark ml-3"></i>
                                    <span class="font-weight-bold text-dark">{{n.subject}}</span>
                                </div>
                                <p class="text-justify mb-2">{{n.description}}</p>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>
            <div class="card card-style" v-if="loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
        </div>

        <div id="notificationHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-Notification.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-Notification.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import VueSimpleAlert from "vue3-simple-alert";
    export default {
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey:"",
                pageLoaded: false,
                notificationList: [],
                loading:false
            };
        },
        computed: {
            NewListCount() {
                return this.$store.getters.GetNotificationCount;
            }
        },
        created() {
            console.log("created");
        },
        methods: {
            GetNotificationList() {
                this.loading = true;
                this.$http.get("Account/GetNotificationList", {
                   
                }).then(data => {
                    this.loading = false;
                    this.notificationList = data.data;
                });
            },
            GetNotifCount() {
                this.$store.dispatch("GetNotificationCountFromServer");
            },
            openDetails(n) {
                this.$http.get("Account/SeenNotification?id=" + n.notificationId);
                this.$router.push(n.linkUrl.replace("/tsk", "").replace("/TSK", ""));
            },
            deleteNotif(n) {
               VueSimpleAlert.confirm("آیا مایل به حذف این پیام هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("Account/DeleteNotif?id=" + n.notificationId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res=="1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.$router.go();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

            this.GetNotifCount();
            this.GetNotificationList();
			
		}
    };
</script>
